module.exports = __webpack_public_path__ + "static/media/template.10c18492.svg";